import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Input from '~~elements/Input';
import Textarea from '~~elements/Textarea';
import Button from '~~elements/Button';
import UploadField from '~~elements/UploadField';
import { TeamResource } from '~~apis/resource';
import TeamHeader from './TeamHeader';
import { TwoColumnStyledForm } from '../Styles';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;
`;

const TeamProfile = ({ teams, reload }) => {
  const [teamIndex, setTeamIndex] = useState(0);

  const [teamData, setTeamData] = useState(teams[0]);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    setTeamData(teams[teamIndex].info);
  }, [teamIndex, teams]);

  const handleInputOnchange = (e) => {
    setTeamData({
      ...teamData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSocialMediaOnchange = (e) => {
    const socialMedia = teamData.social_media;
    if (!socialMedia[e.target.name]) {
      socialMedia[e.target.name] = {
        link: e.target.value,
      };
    } else {
      socialMedia[e.target.name].link = e.target.value;
    }
    setTeamData({
      ...teamData,
      social_media: socialMedia,
    });
  };

  const handleIconUpdate = ({ url, path }) => {
    if (!url || !path) {
      return;
    }

    setTeamData({
      ...teamData,
      icon_url: url,
      icon_path: path,
    });
  };

  const handleIconRemove = (e) => {
    e.preventDefault();
    setTeamData({
      ...teamData,
      icon_url: '',
      icon_path: 'REMOVE',
    });
  };

  const handleIconCancel = (e) => {
    e.preventDefault();
    setTeamData({
      ...teamData,
      icon_url: teams[teamIndex].info.icon_url,
      icon_path: teams[teamIndex].info.icon_path,
    });
  };

  const handleCoverUpdate = ({ url, path }) => {
    if (!url || !path) {
      return;
    }

    setTeamData({
      ...teamData,
      cover_url: url,
      cover_path: path,
    });
  };

  const handleCoverRemove = (e) => {
    e.preventDefault();
    setTeamData({
      ...teamData,
      cover_url: '',
      cover_path: 'REMOVE',
    });
  };

  const handleCoverCancel = (e) => {
    e.preventDefault();
    setTeamData({
      ...teamData,
      cover_url: teams[teamIndex].info.cover_url,
      cover_path: teams[teamIndex].info.cover_path,
    });
  };

  const updateProfile = () => {
    TeamResource.updateTeam({
      teamUniqid: teams[teamIndex].info.uniqid,
      data: {
        ...teamData,
        name: teamData.name.trim(),
        city: teamData.city.trim(),
      },
    })
      .then(() => {
        setSuccessMsg('更新成功！');
        setTimeout(() => reload(), 1000);
      })
      .catch((e) => {
        console.log(e);
        setErrorMsg('更新失敗！請檢查資料或稍候再試');
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');
    if (!teamData.name.trim()) {
      return setErrorMsg('球隊名稱為必填');
    }

    if (!!teamData.social_media?.INSTAGRAM?.link && !teamData.social_media.INSTAGRAM.link.match(/^[0-9a-z._]+$/)) {
      return setErrorMsg('IG 帳號格式有誤，僅能包含 0-9 a-z 與 . _ 符號');
    }
    if (
      !!teamData.social_media?.FACEBOOK?.link &&
      !teamData.social_media.FACEBOOK.link.match(/^https:\/\/www.facebook.com\/.*$/)
    ) {
      return setErrorMsg('facebook 連結格式有誤，開頭需為 https://www.facebook.com/');
    }

    if (teamData.description.length > 200) {
      return setErrorMsg('球隊簡介不得超過 200 字');
    }

    return updateProfile();
  };

  return (
    <StyledDiv>
      {teams.length > 0 && <TeamHeader teams={teams} teamIndex={teamIndex} setTeamIndex={setTeamIndex} />}
      <TwoColumnStyledForm onSubmit={handleSubmit}>
        <div className="box">
          {/* 球隊名稱 */}
          <label>球隊名稱</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder="球隊名稱"
                name="name"
                onChange={handleInputOnchange}
                value={teamData.name}
              />
            </div>
          </div>
          {/* 所在縣市 */}
          <label>所在縣市</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder="所在縣市"
                name="city"
                onChange={handleInputOnchange}
                value={teamData.city}
              />
            </div>
          </div>
          {/* 球隊封面 */}
          <label>球隊封面</label>
          <div className="input-field">
            <div className="cover">
              <div className="cover--box">
                {teamData.cover_url === teams[teamIndex].info.cover_url ? (
                  <>
                    <UploadField
                      styleType="box"
                      url="/api/media"
                      customBtn={(onClick) => (
                        <Button mini nowrap width="unset" color="blue" onClick={onClick}>
                          更改
                        </Button>
                      )}
                      onChange={handleCoverUpdate}
                    />
                    <Button mini nowrap width="unset" color="transparent" onClick={handleCoverRemove}>
                      移除
                    </Button>
                  </>
                ) : (
                  <Button mini nowrap width="unset" color="transparent" onClick={handleCoverCancel}>
                    取消
                  </Button>
                )}
              </div>
              {teamData.cover_url ? (
                <img className="cover--pic" src={teamData.cover_url} alt="avatar" />
              ) : (
                <div className="cover--pic default"></div>
              )}
            </div>
          </div>
          {/* 社群連結 */}
          <div className="input-field">
            <div className="input-box">
              <label>instagram</label>
              <Input
                width="100%"
                placeholder="IG 帳號"
                name="INSTAGRAM"
                onChange={handleSocialMediaOnchange}
                value={teamData.social_media?.INSTAGRAM ? teamData.social_media.INSTAGRAM.link : ''}
              />
            </div>
          </div>
          <div className="input-field">
            <div className="input-box">
              <label>facebook</label>
              <Input
                width="100%"
                placeholder="https://www.facebook.com/xxx"
                name="FACEBOOK"
                onChange={handleSocialMediaOnchange}
                value={teamData.social_media?.FACEBOOK ? teamData.social_media.FACEBOOK.link : ''}
              />
            </div>
          </div>
          {/* 球隊簡介 */}
          <label>球隊簡介</label>
          <div className="input-field">
            <div className="input-box">
              <Textarea
                width="100%"
                height="10rem"
                placeholder="200字內球隊簡介"
                name="description"
                onChange={handleInputOnchange}
                value={teamData.description}
              />
            </div>
          </div>
          <div className="error-msg">{errorMsg}</div>
          <div className="success-msg">{successMsg}</div>
          <Button width="unset" nowrap type="submit" onClick={handleSubmit}>
            更新
          </Button>
        </div>
        <div className="icon">
          {teamData.icon_url ? (
            <img className="icon--pic square" src={teamData.icon_url} alt="avatar" />
          ) : (
            <div className="icon--pic square default"></div>
          )}
          <div className="icon--box">
            {teamData.icon_url === teams[teamIndex].info.icon_url ? (
              <>
                <UploadField
                  styleType="box"
                  url="/api/media"
                  customBtn={(onClick) => (
                    <Button mini nowrap width="unset" color="blue" onClick={onClick}>
                      更改
                    </Button>
                  )}
                  onChange={handleIconUpdate}
                />
                <Button mini nowrap width="unset" color="transparent" onClick={handleIconRemove}>
                  移除
                </Button>
              </>
            ) : (
              <Button mini nowrap width="unset" color="transparent" onClick={handleIconCancel}>
                取消
              </Button>
            )}
          </div>
        </div>
      </TwoColumnStyledForm>
    </StyledDiv>
  );
};

export default TeamProfile;
